<template>
  <div class="login-firstTime">
    <div id="page-content-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-7 loginLeft">
            <img src="assets/images/login-graphic.png" alt="" />
          </div>

          <div class="col-md-5 loginRight">
            <div class="loginWrapper">
              <div class="loginText">
                <h2
                  v-if="notFinishedRegistration === true"
                  style="color: 15px !important;"
                >
                  Please enter the code sent to your mobile to complete
                  registration<br />
                  If you don’t receive the sms within 5 minutes you can try
                  again
                </h2>
                <h2 v-if="notFinishedRegistration === false">
                  Please, confirm your registration:
                </h2>
                <p class="registeredPhone">Registered Phone number</p>
                <p class="registeredPhoneNum">
                  xxxxxxx{{ lastThreePhoneDigits }}
                </p>
              </div>

              <div class="loginControls regNo">
                <form action="form" @submit.prevent="confirmReg">
                  <input
                    type="text"
                    maxlength="1"
                    id="digit1ConfirmReg"
                    name="digit1"
                    v-model="digit1"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit2ConfirmReg"
                    name="digit2"
                    v-model="digit2"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit3ConfirmReg"
                    name="digit3"
                    v-model="digit3"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit4ConfirmReg"
                    name="digit4"
                    v-model="digit4"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit5ConfirmReg"
                    name="digit5"
                    v-model="digit5"
                    @keypress="onlyNumber"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    id="digit6ConfirmReg"
                    name="digit6"
                    v-model="digit6"
                    @keypress="onlyNumber"
                  />

                  <p class="remaining">
                    If you couldn't receive the SMS within 5 minutes you can try
                    again<br /><span>3:45</span> Remaining
                  </p>
                  <button type="button">Send Again</button>
                  <button
                    v-if="isConfirmRegistrationButtonLoading === true"
                    type="submit"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Confirmation...
                  </button>
                  <button
                    v-if="isConfirmRegistrationButtonLoading === false"
                    type="submit"
                  >
                    Confirm
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import actions from "@/store/authentication/actions";
export default {
  data: () => ({
    digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
    digit5: "",
    digit6: ""
  }),
  computed: {
    lastThreePhoneDigits: {
      get() {
        return this.$store.state.authentication.phone.slice(
          this.$store.state.authentication.phone.length - 3
        );
      }
    },
    notFinishedRegistration: {
      get() {
        return this.$store.state.authentication.notFinishedRegistration;
      }
    },
    isConfirmRegistrationButtonLoading: {
      get() {
        return this.$store.state.settings.isConfirmRegistrationButtonLoading;
      },
      set(value) {
        this.$store.commit(
          "updateIsConfirmRegistrationButtonLoadingMutation",
          value
        );
      }
    }
  },
  methods: {
    onlyNumber: function($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      const symbol = String.fromCharCode(keyCode);

      if (/^\s*$/.test(symbol) || isNaN(symbol)) {
        $event.preventDefault();
      } else {
        const inputId = $event.target.id;

        switch (inputId) {
          case "digit1ConfirmReg":
            this.digit1 = symbol;
            break;
          case "digit2ConfirmReg":
            this.digit2 = symbol;
            break;
          case "digit3ConfirmReg":
            this.digit3 = symbol;
            break;
          case "digit4ConfirmReg":
            this.digit4 = symbol;
            break;
          case "digit5ConfirmReg":
            this.digit5 = symbol;
            break;
          case "digit6ConfirmReg":
            this.digit6 = symbol;
            break;
          default:
            break;
        }

        $event.preventDefault();
        $event.target.nextElementSibling.focus();
      }
    },
    confirmReg: async function() {
      const confirmRegistrationCode = `${this.digit1}${this.digit2}${this.digit3}${this.digit4}${this.digit5}${this.digit6}`;

      if (confirmRegistrationCode.length != 6) {
        this.$store.commit(
          "updateGenericErrorModalMessageMutation",
          "Sms code was not entered"
        );
        this.$store.commit("updateIsGenericErrorModaleActiveMutation", true);
        return;
      }

      this.isConfirmRegistrationButtonLoading = true;
      await this.$store.dispatch(
        actions.FINISH_REGISTRATION,
        confirmRegistrationCode
      );
    }
  }
};
</script>
